


































import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import ProjectRulesComponent from '@/views/project/project-rules.component.vue';
import CustomFieldService from '@/domain/custom-field/custom-field.service';
import CustomField from '@/domain/custom-field/custom-field.entity';
import ModalConfirm from '@/shared/modals/modal-confirm.component.vue';
import ProjectCustomFieldRegister from './project-custom-field-register.component.vue';
import ProjectCustomFieldDelete from './project-custom-field-delete.component.vue';

@Component({
  components: {
    ProjectRulesComponent,
    ModalConfirm,
    ProjectCustomFieldDelete,
    ProjectCustomFieldRegister,
  },
})
export default class ProjectCustomFieldComponent extends Vue {
  @Prop() projectId!: string;

  customFields: CustomField[] = [];

  dialogModal = false;

  dialogModalRegister = false;

  customFieldId = '';

  @Watch('projectId')
  watchProjectId() {
    this.initCustomFields();
  }

  private initCustomFields() {
    CustomFieldService
      .getByProjectId(this.projectId)
      .then(fields => this.customFields = fields);
  }

  newCustomField() {
    this.dialogModalRegister = true;
  }

  deleteCustomField(id: string) {
    this.customFieldId = id;
  }

  deletedCustomField() {
    this.clearCustomFieldId();
    this.initCustomFields();
  }

  clearCustomFieldId() {
    this.customFieldId = '';
  }
}
